import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeProfilePicture, updateProfile } from "../../services/api";
import { setRefetch, setUserData } from "../../store/reducers/listingReducer";
import { Spinner } from "../ui/Spinner";
import { ErrorMessage, Field, useFormik } from "formik";
import { countryOptions } from "../../helpers/countryList";

export const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.listingReducer.userData);
  const inputRef = useRef<HTMLInputElement>(null);

  const [file, setFile] = useState<File | undefined>();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const formik = useFormik({
    initialValues: {
      first_name: userData?.first_name || "",
      last_name: userData?.last_name || "",
      country: userData?.phone ? userData?.phone.split(" ")[0] : "",
      phone: userData?.phone ? userData?.phone.split(" ")[1] : "",
      sms: userData?.sms || false,
    },
    onSubmit(values) {
      //console.log(values);
      changeProfileData(values);
    },
    enableReinitialize: true,
  });

  async function changeProfileData(values: any) {
    setLoading(true);
    try {
      const submitValues = { ...values };
      submitValues.sms = submitValues.sms ? 1 : 0;
      submitValues.phone = `${submitValues.country} ${submitValues.phone}`;
      const formData = new FormData();
      Object.keys(submitValues).forEach((key) =>
        formData.append(key, submitValues[key])
      );
      if (file) {
        formData.append("file", file);
      }
      formData.append(
        "notification_frequency",
        userData.user_preference?.notification_frequency || "every_10_listings"
      );
      let changeResponse = await updateProfile(formData);
      if (changeResponse) {
        dispatch(setUserData(changeResponse.data.data));
      }

      dispatch(setRefetch(true));
      setLoading(false);
    } catch (e) {
      console.error(e);
      setErrorMessage("Upload failed. Please try again.");
      setLoading(false);
    }
  }

  return (
    <div className="w-full p-6">
      <form onSubmit={formik.handleSubmit}>
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">Profile</h3>
          <div className="flex">
            <button
              className="bg-primary px-4 py-2 text-white font-semibold text-sm flex gap-x-3"
              disabled={loading}
              type="submit"
            >
              {loading ? <Spinner /> : null}
              Save
            </button>
            <button onClick={() => navigate("/")} className="h-10 w-10">
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>

        <div className="mt-6">
          <div className="flex gap-x-8">
            <div className="grid grid-cols-2 gap-4 flex-1">
              <div className="flex flex-col gap-y-2">
                <label
                  htmlFor="primary-name"
                  className="text-sm font-medium text-gray-700"
                >
                  First Name
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="first_name"
                  id="primary-name"
                  onChange={formik.handleChange}
                  value={formik.values.first_name}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Last Name
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="last_name"
                  id="primary-name"
                  onChange={formik.handleChange}
                  value={formik.values.last_name}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  htmlFor="state"
                  className="text-sm font-medium text-gray-700"
                >
                  Country
                </label>
                <select
                  name="country"
                  className="border px-4 py-2 outline-none w-full"
                  onChange={formik.handleChange}
                  value={formik.values.country}
                >
                  <option className="p-2" disabled value="">
                    Select country
                  </option>
                  {countryOptions.map((itm) => (
                    <option value={itm.value}>{itm.label}</option>
                  ))}
                </select>
                {/* <ErrorMessage name="country">
                  {(msg) => (
                    <div className="text-xs text-red-500 mt-2">{msg}</div>
                  )}
                </ErrorMessage> */}
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Phone Number
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="phone"
                  id="primary-name"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Email Address
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="email"
                  name="primary-name"
                  id="primary-name"
                  value={userData?.email}
                  readOnly
                />
              </div>

              <div className="flex flex-col gap-y-2 col-span-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Profile Image
                  <div className="mt-2">
                    {file ? (
                      <div className="flex justify-center">
                        <img
                          className="w-28 h-28 object-fit-cover"
                          src={URL.createObjectURL(file)}
                          alt="avatar"
                        />
                      </div>
                    ) : null}
                    <div className="mt-5">
                      <button
                        className="w-full border py-4 px-6"
                        onClick={() => inputRef.current?.click()}
                      >
                        <span className="text-primary text-sm font-semibold">
                          Click to upload
                        </span>
                        {/* <span>
                        {" "}
                        or drag and drop <br /> PNG or JPG
                      </span> */}
                      </button>
                    </div>
                    <input
                      className="hidden border px-4 py-2 outline-none"
                      type="file"
                      name="primary-name"
                      id="primary-name"
                      ref={inputRef}
                      accept=".jpeg,.jpg,.png"
                      onChange={(e) =>
                        setFile(e.target.files ? e.target.files[0] : undefined)
                      }
                    />
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div className="flex gap-x-8 mt-6">
            <div className="grid grid-cols-2 gap-4 flex-1">
              <div className="flex flex-col gap-y-2">
                <label
                  htmlFor="primary-name"
                  className="text-sm font-medium text-gray-700"
                >
                  Company Name
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="primary-name"
                  id="primary-name"
                  readOnly
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Company URL
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="primary-name"
                  id="primary-name"
                  readOnly
                />
              </div>

              <div className="flex items-center gap-x-2">
                <input
                  className="border w-4 h-4"
                  type="checkbox"
                  id="vacant"
                  name="sms"
                  onChange={formik.handleChange}
                />
                <label
                  className="font-medium text-sm text-gray-700"
                  htmlFor="vacant"
                >
                  SMS Notification
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
